module.exports = __webpack_public_path__ + "img/5.44480964.jpg";